import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppConstants, ConfirmDataConfig } from '@nibras/core';

@Component({
  selector: 'generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.scss']
})
export class GenericDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: ConfirmDataConfig,
    private dialogRef: MatDialogRef<GenericDialogComponent>
  ) {}
  public rememberThis: boolean;

  public cancel() {
    this.close(false);
  }

  private close(value: boolean) {
    this.dialogRef.close(value);
  }

  public confirm() {
    if (this.data?.rememberKey && this.rememberThis != undefined) {
      localStorage.setItem(this.data.rememberKey, this.rememberThis.toString());
    }
    this.close(true);
  }

  public neverAskAgain() {
    if (this.data && this.data.rememberKey) {
      localStorage.setItem(this.data.rememberKey, AppConstants.REMEMBER_KEYS.NEVER_ASK_VALUE);
    }
    this.cancel();
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.dialogRef.close();
  }
}
